export default __webpack_public_path__ + "static/media/embarazadas_vih@2x.11d28af2.png";